import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"height":"12px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1)
const _hoisted_2 = {
  key: 0,
  class: "col q-ma-sm no-padding"
}
const _hoisted_3 = { class: "col q-ma-sm no-padding" }
const _hoisted_4 = { class: "col q-ma-sm no-padding" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"height":"50px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1)
const _hoisted_6 = { class: "row q-pt-md" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "row q-pt-md" }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BigCard = _resolveComponent("BigCard")!
  const _component_MainContent = _resolveComponent("MainContent")!
  const _component_Card = _resolveComponent("Card")!
  const _component_GreenTitle = _resolveComponent("GreenTitle")!
  const _component_CarouselTest = _resolveComponent("CarouselTest")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainContent, null, {
      default: _withCtx(() => [
        (_ctx.getLocalePanel(0))
          ? (_openBlock(), _createBlock(_component_BigCard, {
              key: 0,
              title: _ctx.getLocalePanel(0)?.title,
              desc: _ctx.getLocalePanel(0)?.description,
              path: "kompat",
              url: (_ctx.baseApi || '') + _ctx.getLocalePanel(0)?.banner || ''
            }, null, 8, ["title", "desc", "url"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_MainContent, null, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", {
          class: _normalizeClass({ row: _ctx.$q.screen.gt.xs})
        }, [
          (_ctx.homePanels[1])
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_Card, {
                  title: _ctx.homePanels[1]?.title,
                  desc: _ctx.homePanels[1]?.description,
                  path: "osmo",
                  url: (_ctx.baseApi  || '') + _ctx.homePanels[1]?.banner  || '',
                  selectable: false
                }, null, 8, ["title", "desc", "url"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.homePanels[2])
              ? (_openBlock(), _createBlock(_component_Card, {
                  key: 0,
                  title: _ctx.homePanels[2]?.title,
                  desc: _ctx.homePanels[2]?.description,
                  path: "product",
                  url: (_ctx.baseApi || '') + _ctx.homePanels[2]?.banner || '',
                  selectable: false
                }, null, 8, ["title", "desc", "url"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.getLocalePanel(3))
              ? (_openBlock(), _createBlock(_component_Card, {
                  key: 0,
                  title: _ctx.getLocalePanel(3)?.title,
                  desc: _ctx.getLocalePanel(3)?.description,
                  path: "faq",
                  url: (_ctx.baseApi  || '') + _ctx.getLocalePanel(3)?.banner,
                  selectable: false
                }, null, 8, ["title", "desc", "url"]))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ]),
      _: 1
    }),
    _createVNode(_component_MainContent, null, {
      default: _withCtx(() => [
        _hoisted_5,
        _createVNode(_component_GreenTitle, {
          title: _ctx.$t('Home.News.Title')
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "col",
            innerHTML: _ctx.$t('News.Introduction')
          }, null, 8, _hoisted_7)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_MainContent, null, {
      default: _withCtx(() => [
        _createVNode(_component_CarouselTest, { news: _ctx.news }, null, 8, ["news"])
      ]),
      _: 1
    }),
    _createVNode(_component_MainContent, null, {
      default: _withCtx(() => [
        _createVNode(_component_GreenTitle, {
          title: _ctx.$t('Disclaimer.Title')
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "col",
            innerHTML: _ctx.$t('Disclaimer.Text')
          }, null, 8, _hoisted_9)
        ])
      ]),
      _: 1
    })
  ], 64))
}